import { AsyncPipe } from '@angular/common';
import { Component, ChangeDetectionStrategy } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'payment-details-report',
  templateUrl: './payment-details-report.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [AsyncPipe],
})
export class PaymentDetailsReportComponent {
  additionData: Observable<any> = new BehaviorSubject(null);
  columnData: Observable<any> = new BehaviorSubject(null);

  getPaymentDetailsReport(value: any) {
    if (value?.clt_pay_token_masked_card_number) {
      if (Object.keys(value?.clt_pay_token_masked_card_number).length === 0)
        return '-';
      return value?.clt_pay_token_masked_card_number;
    } else if (value?.clt_pay_token_masked_account_number) {
      if (Object.keys(value?.clt_pay_token_masked_account_number).length === 0)
        return '-';
      return value?.clt_pay_token_masked_account_number;
    } else return '-';
  }
}
